module.exports = __webpack_public_path__ + "static/media/6.10.dd1c4905.png";